var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithubFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: -2,
    width: 36,
    height: 35,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_49_21",
    transform: "matrix(0.0208333 0 0 0.0214286 0 -0.0142857)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_49_21",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC6klEQVR4nO2ZXWiNcRzHz4zN2ETLSy2JXVhDCqG2FHLtQimkKHnPaHYxL6XceK3hYnZNKRerkTuRyGtrDYlYUubdhTIW8dGP/+rxOOf5//7P83/Ops6nzs15zvl+v7/zPP+X3/9kMgUKFPACMA1YBRwFLgOPgTfAR6AHuAucARqB2UDRUAhdAWwAbuLOC+AAUDUYwUeYX/ITyfkKtACV+Qq/GHiEf94CK9IOvxH4Trq0yR32HXw40Er+uACU+CzgNPmnAyj2EX43g8expOGXAT9yiO8DxgPrga4Y4WSdaACmADURn1seN/xI4GmEcE3gs8OATWZKtNEPbJNxlfnbLxe9wNg4Bey3BPlnkAELzJ1ZJAsUUGZeVeY9ubYwh18UR1zDjwP6IiU9zhJAicVLskx0EdyBnQkeC5ik8NvjItitEFzqsYAlCr9nqg0gUKsQe+dzE8afMSKaNmZqxNYphFb6Cj+A7IMUvrsyNoBTFpGuNPbyQBFwx+J9ViN0PfGvEL+I7RbvTo3I/cTPYfwCai3erzUiTywiFSl3eFH0aUSeD+EC+n08QjNSLGCWxbtXI9JuEWlMsYAmi3e3RuSwRUQesbIUwo8yJxVRXNQIrcVOawoFtCl8mzVClcrGvSW8p0/Qb59AR71W9IpSUFbOugTh64F7Sq8PQKlWeDNu3AK2ANUK7WpgK3Db0eO4azv5MiSwBpgPPEwyQ0l3hTs/genqAoyR9K1hVput76ss1zqUusWKtSbMOafwxqjUnBwE6TG7xjrgW9wGxxwIa/kMTHYuwBjNMacIQeYGzkgfAF+AGzKPO+hOdSigKVb4gNnOkOB5T6fbGtoT9x7mkTkZEm7wUIQNGSflSX2CRcjCFZ4695om5KDnAjrl1M9L+JBpc5bB+xuPBVwFxngPHzCel63piaETRrYvh7z/N5DDvNzcjfcD5jE0ZHEa4JrMeOmkjQ4xWpp8malifFc2cJdkOk4nXYECBTL/A78AmTCR9xr7/VMAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubFooter);
export default __webpack_public_path__ + "static/media/github-footer.fcafc4929f47bdcc24950a771cebae15.svg";
export { ForwardRef as ReactComponent };